const texts = {
  'los_fen': 'Движением частиц материи убитый, упал он наземь, материей прикрытый',
  'los_ban': 'Стемнело вдруг в глазах, банан не смог помочь',
  'los_tuf': 'Как трудно устоять на замшевой коже планеты',
  'los_van': 'Весь воздух удален и нечем тут дышать',
  'los_yad': 'Один глоток казался несмертельным',

  'snk_fen': 'Ты всё продул и всё начнёшь сначала, не пожалев того, что приобрел',
  'snk_ban': 'С бананом в бой вступив, змеёю нахлебавши',
  'snk_tuf': 'Рука тверда, дух чёрен, крепок яд',
  'snk_van': 'Всё очевидно: отравлен поцелуй',
  'snk_yad': 'Мгновение победы, но смерть была быстрей',

  'pis_fen': 'Задуть до смерти не успел, погубила дура',
  'pis_ban': 'О, Боги, голод убивает нас!',
  'pis_tuf': 'Обычай соблюдал, но оступился малость',
  'pis_van': 'Присосал блаженно, но чихнул смертельно',
  'pis_yad': 'Смерть принял из-за жалости своей',

  'los': 'Йорик, жизнь моя скучна',
  'snk': 'Йорик, жизнь моя скучна',
  'pis': 'Йорик, жизнь моя скучна',
};

export default texts;



/** WEBPACK FOOTER **
 ** ./src/client/texts.js
 **/